import styled from 'styled-components';
import { Form } from 'formik';
import { units } from '../../../../helpers/styles/units';
import { FontWeight } from '../../../../constants/Styles/fontWeight';
import { UploadPhotoWithMiniature } from '../../../../components/UploadPhotoWithMiniature';
import { typography } from '../../../../helpers/styles/typography';
import { colors } from '../../../../constants/Colors';
import { Input } from '../../../../components/Input';
import { Button } from '../../../../components/Button';

export const RootWrapper = styled.div`
  position: relative;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  /* padding-left: ${units(12)}; */
  margin-bottom: ${units(63)};
`;

export const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(30)};

  max-width: ${units(322)};
  width: 100%;
`;

export const FieldsWrapper = styled(MainWrapper)`
  gap: ${units(12)};
`;

export const StyledInput = styled(Input)`
  margin-bottom: 0;
  font-weight: ${FontWeight.REGULAR};
  letter-spacing: 0.8px;

  background-color: ${colors.light};

  ${typography(10)};
`;

export const StyledButton = styled(Button)`
  width: 100%;
`;

export const InpurWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${units(12)};
  // margin-bottom: ${units(20)};
`;

export const StyledForm = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: ${units(20)};
  gap: ${units(40)};
`;

export const Uploader = styled(UploadPhotoWithMiniature)`
  width: 100%;
  // margin-bottom: ${units(20)};
`;

export const DeleteButton = styled(StyledButton)`
  width: fit-content;
`;

export const AddButton = styled(StyledButton)`
  width: fit-content;
  display: flex;
  align-items: center;
  padding: 0;
  gap: ${units(8)};

  font-weight: ${FontWeight.BOLD};
  border: none;
  &:hover {
    border: none;
  }
`;

export const FlexWrapper = styled.div`
    display: flex;
  flex-direction: column;
  gap: ${units(20)}
`;
